var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(this.headerFooter.header,{tag:"component"}),_c('div',{staticClass:"container"},[_c('ReportInfo',{attrs:{"reportInfo":_vm.reportInfo}}),_c('SpReport',{staticStyle:{"margin-top":"60px"}}),_c('ReportAllData',{staticStyle:{"margin-top":"20px"}}),_c('AI',{staticStyle:{"margin-top":"20px","margin-bottom":"60px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }